import { render, staticRenderFns } from "./menu-button.vue?vue&type=template&id=73191eb9&scoped=true&"
import script from "./menu-button.vue?vue&type=script&lang=js&"
export * from "./menu-button.vue?vue&type=script&lang=js&"
import style0 from "./menu-button.vue?vue&type=style&index=0&id=73191eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73191eb9",
  null
  
)

export default component.exports